module.exports = __webpack_public_path__ + "media/images/play-17edb533.svg";